import React from 'react';

import {CSVDownload} from 'react-csv';

import 'react-day-picker/lib/style.css';

import './DailyReport.css';

class DailyReport extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      day1:'0',
      month1:'0',
      year1:'0',
      day2:'0',
      month2:'0',
      year2:'0',
      data:[],
      ddata:false,
      csvList:[],
     schoolList:[],
     showclasses:false,
     showdates:false,
     grades:[],
     dataClasses:[],

    }
  }


    async componentDidMount(){
      fetch('https://schoolportal.appsdesign.co.za/daily-list/' + await localStorage.getItem('schoolToken'))
      .then((response) => response.json())
      .then((responseJson) => {
    console.log(responseJson[0])
        this.setState({
          data: responseJson,

    }, function(){

        });
  console.log(this.state.data)
      })
      .catch((error) =>{
        console.error(error);
      });



      fetch('https://schoolportal.appsdesign.co.za/get_class/' + localStorage.getItem('schoolToken'))
      .then((response) => response.json())
      .then((responseJson) => {
    console.log(responseJson[0])
        this.setState({
          dataClasses: responseJson,

    }, function(){

        });
    console.log(this.state.data)
      })
      .catch((error) =>{
        console.error(error);
      });



      }


      onDownLoad = ()=>{

        this.setState({

          ddata:true
        });

      }



  onDay1Change = (event) =>{

    this.setState({day1:event.target.value});
  }

  onMonth1Change = (event) =>{

    this.setState({month1:event.target.value});
  }

  onYear1Change = (event) =>{

    this.setState({year1:event.target.value});
  }



  onDay2Change = (event) =>{

    this.setState({day2:event.target.value});
  }

  onMonth2Change = (event) =>{

    this.setState({month2:event.target.value});
  }

  onYear2Change = (event) =>{

    this.setState({year2:event.target.value});
  }


onchangeShowClasses = () =>{

  this.setState({
    showclasses:!this.state.showclasses ? true : false,
    showdates:false
  });
}

onchangeShowDates = () =>{

  this.setState({
    showdates:!this.state.showdates ? true : false,
    showclasses:false,
  });
}

createReportFromClas = (val) =>{

  for(let a = 0; a < this.state.grades.length; a++){
    if(val[0] !== undefined){

  if(val[0].childclass === this.state.grades[a]){

  return true

  }
  }
}
}


createReport = (val) =>{


    var year1 = Number(this.state.year1);

    var year2 = Number(this.state.year2);

    var month1 = Number(this.state.month1);

    var day1 = Number(this.state.day1);

    var yearrun = year2 - year1;

     yearrun = yearrun !== 0 ? yearrun : 1;

     yearrun = yearrun > 1 ? yearrun : 1;


    var monthrun1 = Number(this.state.month2) - Number(this.state.month1);

    //var monthrun2 = monthrun1 !== 0 ? yearrun : monthrun1;




    //var month1check = 12 - (12 - Number(this.state.month1));

    //var month2check = 12 - (12 - Number(this.state.month2));

    //var monthcheck = month1check + (12 * (yearrun -1)) + month2check;

     var monthrun = monthrun1 !== 0 ? monthrun1 : 1;



    var dayrun1 = Number(this.state.day1);

    var dayrun2 = Number(this.state.day2);

    var dayruncheck = dayrun1 - dayrun2;

    var dayrun = dayruncheck > 0 ? 31 : dayruncheck;

  //  var dayruncheck = dayrun1 - dayrun2;
    dayruncheck = 31 - dayruncheck;

    dayrun = dayrun < 0 ? dayruncheck : dayrun


  for(let z = 0; z < yearrun ; z++){
  for(let q = 0; q <= monthrun ; q++){

  for(let a = 0; a <= dayrun; a++){

    var date = (day1 + a ) +'-'+ (month1 + q) +'-'+ (year1 + z)

    var date1 = (day1 + a ) + (month1 + q) + (year1 + z);

    var date2 = Number(this.state.day2) + Number(this.state.month2) + Number(this.state.year2);

    if(val.date === date && date1 <= date2){

    //alert('the date :' + date );


    return true

    }
  }

  }
  }



  }

getClassList= () =>{

const list = this.state.data.filter(detail => {

var reportA = this.createReportFromClas(detail.Schoolclass);
if(reportA){

 console.log('get list', detail.Schoolclass)
 return detail

}
return null


});

const list2 = list.map(detail => {
console.log('thelist 1', list)

//
// var sList = this.state.schoolList;
//
// sList.unshift(detail.Schoolclass);
//
//
// this.setState({schoolList:sList}, function(){ alert(sList[0])});

var listA = detail.Schoolclass

   listA.date = detail.date;
   listA.timein = detail.timein;

 return listA

});

let alist = [];
for (let t = 0; t < list2.length; t++){
for(let y = 0; y < list2[t].length; y++){

list2[t][y].date = list2[t].date;
list2[t][y].timein = list2[t].timein;

alist.unshift(list2[t][y]);
}
}

console.log('alist', alist);

 const thelist = alist.map((d,i) => {

console.log('thelist 2', list2)

 return {
   date:d.date,
   childname: d.childname,
   childsurname: d.childsurname,
   childclass:d.childclass,
   absent: d.absent,
   collectorname: d.collectorname,
   collectorno:d.collectorno,
   collectedat:d.collectedat,
   timein:d.timein,

  }


});


//
let l = JSON.stringify(thelist);
//
//
//   alert(l);
//
l = JSON.parse(l);
//
// alert(l);

this.setState({
  csvList:l,
  schoolList:l,
});
//alert(JSON.stringify(csvDetails));



}


  getList = () =>{

  const list = this.state.data.filter(detail => {

var reportA = this.createReport(detail);
  if(reportA){

   console.log('get list', detail.Schoolclass)
   return detail

  }
  return null


  });

  const list2 = list.map(detail => {
console.log('thelist 1', list)

//
// var sList = this.state.schoolList;
//
// sList.unshift(detail.Schoolclass);
//
//
// this.setState({schoolList:sList}, function(){ alert(sList[0])});

 var listA = detail.Schoolclass

     listA.date = detail.date;
     listA.timein = detail.timein;

   return listA

  });

let alist = [];
for (let t = 0; t < list2.length; t++){
  for(let y = 0; y < list2[t].length; y++){

list2[t][y].date = list2[t].date;
list2[t][y].timein = list2[t].timein;

  alist.unshift(list2[t][y]);
}
}

console.log('alist', alist);

   const thelist = alist.map((d,i) => {

console.log('thelist 2', list2)

   return {
     date:d.date,
     childname: d.childname,
     childsurname: d.childsurname,
     childclass:d.childclass,
     absent: d.absent,
     collectorname: d.collectorname,
     collectorno:d.collectorno,
     collectedat:d.collectedat,
     timein:d.timein,

    }


  });


//
let l = JSON.stringify(thelist);
//
//
//   alert(l);
//
  l = JSON.parse(l);
//
// alert(l);

  this.setState({
    csvList:l,
    schoolList:l,
  });
  //alert(JSON.stringify(csvDetails));



  }

addClassToReport = (val) =>{


var grades = this.state.grades;

grades.unshift(val);

this.setState({grades:grades},function(){console.log('added') })

}

render(){

// const classesView = this.state.dataClasses.map((c,i) =>{
// return(
// <div>
// <input key={i} type="checkbox" onClick={() => this.addClassToReport(c.assClass)} value={c.assClass}/>
//  {c.assClass}
//  </div>
// )
//
// })


const schoolclasses = this.state.dataClasses.map((schoolclass, i) => {

return(

  <option key={i} value={schoolclass.assClass}>{schoolclass.assClass}</option>
)


});





const listView = this.state.schoolList.map((item,i) =>{

return(
<tr key={i}>
<td>{item.date}</td>
<td>{item.childclass}</td>
<td>{item.schoolID}</td>
<td>{item.category}</td>
<td>{item.childsurname}</td>
<td>{item.childname}</td>

<td>{item.absent ? 'Yes' : 'No'}</td>

<td>{item.collectorno}</td>
<td>{item.collectorname}</td>
<td>{item.timein}</td>
<td>{item.collectedat}</td>



</tr>

)

})

  //
  // const schoolLists = this.state.data.map((l, i) => {
  //
  // return(
  //
  //   <option key={i} value={l.date}>{l.date}</option>
  // )
  //
  //
  // });


  const csvData = this.state.csvList;


return(

  <div className="ma2 pa2 br3 shadow-4" style={{display:'flex', flexDirection:'column', justifyContent:'left', margin:100,backgroundColor:'white'}}>
<h1> Report </h1>



<div style={{display:'flex', flexDirection:'row', justifyContent:'center'}}>


<button  style={{margin:3, height:40}} className="br2 bg-blue br-blue" onClick={this.onchangeShowDates}>Select Dates View</button>

{

  this.state.showdates ?
<div style={{display:'flex', flexDirection:'column', justifyContent:'space-between'}}>
FROM
<div style={{display:'flex', flexDirection:'row', justifyContent:'center'}}>
<select onChange={this.onDay1Change}>
<option value="0">Day</option>
<option value='1'>1</option>
<option value='2'>2</option>
<option value='3'>3</option>
<option value='4'>4</option>
<option value='5'>5</option>
<option value='6'>6</option>
<option value='7'>7</option>
<option value='8'>8</option>
<option value='9'>9</option>
<option value='10'>10</option>
<option value='11'>11</option>
<option value='12'>12</option>
<option value='13'>13</option>
<option value='14'>14</option>
<option value='15'>15</option>
<option value='16'>16</option>
<option value='17'>17</option>
<option value='18'>18</option>
<option value='19'>19</option>
<option value='20'>20</option>
<option value='21'>21</option>
<option value='22'>22</option>
<option value='23'>23</option>
<option value='24'>24</option>
<option value='25'>25</option>
<option value='26'>26</option>
<option value='27'>27</option>
<option value='28'>28</option>
<option value='29'>29</option>
<option value='30'>30</option>
<option value='31'>31</option>

</select>
<select onChange={this.onMonth1Change}>
<option value="0">Month</option>
<option value='1'>January</option>
<option value='2'>Febuary</option>
<option value='3'>March</option>
<option value='4'>April</option>
<option value='5'>May</option>
<option value='6'>June</option>
<option value='7'>July</option>
<option value='8'>August</option>
<option value='9'>September</option>
<option value='10'>October</option>
<option value='11'>Novemebr</option>
<option value='12'>December</option>
</select>

<select onChange={this.onYear1Change}>
<option value="0">Year</option>
<option value='2019'>2019</option>
<option value='2020'>2020</option>
<option value='2021'>2021</option>
<option value='2022'>2022</option>
<option value='2023'>2023</option>
<option value='2024'>2024</option>
</select>
</div>

TO

<div style={{display:'flex', flexDirection:'row', justifyContent:'center'}}>

<select onChange={this.onDay2Change}>
<option value="0">Day</option>
<option value='1'>1</option>
<option value='2'>2</option>
<option value='3'>3</option>
<option value='4'>4</option>
<option value='5'>5</option>
<option value='6'>6</option>
<option value='7'>7</option>
<option value='8'>8</option>
<option value='9'>9</option>
<option value='10'>10</option>
<option value='11'>11</option>
<option value='12'>12</option>
<option value='13'>13</option>
<option value='14'>14</option>
<option value='15'>15</option>
<option value='16'>16</option>
<option value='17'>17</option>
<option value='18'>18</option>
<option value='19'>19</option>
<option value='20'>20</option>
<option value='21'>21</option>
<option value='22'>22</option>
<option value='23'>23</option>
<option value='24'>24</option>
<option value='25'>25</option>
<option value='26'>26</option>
<option value='27'>27</option>
<option value='28'>28</option>
<option value='29'>29</option>
<option value='30'>30</option>
<option value='31'>31</option>

</select>
<select onChange={this.onMonth2Change}>
<option value="0">Month</option>
<option value='1'>January</option>
<option value='2'>Febuary</option>
<option value='3'>March</option>
<option value='4'>April</option>
<option value='5'>May</option>
<option value='6'>June</option>
<option value='7'>July</option>
<option value='8'>August</option>
<option value='9'>September</option>
<option value='10'>October</option>
<option value='11'>Novemebr</option>
<option value='12'>December</option>
</select>

<select onChange={this.onYear2Change}>
<option value="0">Year</option>
<option value='2019'>2019</option>
<option value='2020'>2020</option>
<option value='2021'>2021</option>
<option value='2022'>2022</option>
<option value='2023'>2023</option>
<option value='2024'>2024</option>

</select>
</div>





<button  style={{margin:3, height:40}} className="br2 bg-blue br-blue" onClick={this.getList}>Generate Report</button>








</div>
: null

}

<div>
<button  style={{margin:3, height:40}} className="br2 bg-blue br-blue" onClick={this.onchangeShowClasses}>Select Classes listView</button>

{

  this.state.showclasses ?
<div>

<p>Hold down the ctrl (Windows) or cmd (Mac) button to select more than one.</p>
<select
multiple="true"
onChange={(event) => this.addClassToReport(event.target.value)}
>
<option value="">Please select class/classes</option>
{schoolclasses}
 </select>

<button  style={{margin:3, height:40}} className="br2 bg-blue br-blue" onClick={this.getClassList}>Generate Report</button>
</div>
: null

}
</div>



      </div>



      {
        this.state.ddata ?
      <CSVDownload data={csvData} target="_blank" />
      : null
      }



      <table style={{ margin:10}}>
       <tbody>
      <tr>
      <td><button  style={{margin:3, height:40}} className="br2 bg-blue br-blue" onClick={this.onDownLoad}>Download Report</button></td>
      </tr>
      <tr>
      <th>Date</th><th>Class</th><th>Child No</th><th>Category</th><th>Child Surname</th><th>Child Name</th><th>Child Absent</th><th>Code Generated By</th><th>Collected By</th><th>Time In</th><th>Time Out</th>
      </tr>
     {listView}
       </tbody>
      </table>



      </div>
)

}

}

export default DailyReport;



// WEBPACK FOOTER //
// ./src/components/DailyReport/DailyReport.js